import React, { Component, Fragment } from 'react';

export class Pagination extends Component {
  constructor(props){
    super(props)

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleFastRewindClick = this.handleFastRewindClick.bind(this);
    this.handlePreviousButtonClick = this.handlePreviousButtonClick.bind(this);
    this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
    this.handleFastForwardClick = this.handleFastForwardClick.bind(this);
    this.renderPageButtons = this.renderPageButtons.bind(this);
    this.nextButtonDisabled = this.nextButtonDisabled.bind(this);
    this.previousButtonDisabled = this.previousButtonDisabled.bind(this);
  }

  handlePageClick(event){
    this.props.handlePageClick(event.target.value)
  }

  handleFastRewindClick(event) {
    this.props.handleFastRewindClick(event.target.value)
  }

  handlePreviousButtonClick(event){
    this.props.handlePreviousButtonClick(event.target.value)
  }

  handleNextButtonClick(event){
    this.props.handleNextButtonClick(event.target.value)
  }

  handleFastForwardClick(event) {
    this.props.handleFastForwardClick(event.target.value)
  }

  renderPageButtons() {
    const {currentPage, totalPages} = this.props;
    const maxPagesShown = 5;

    let endPage = Number(currentPage) + 2
    let firstPage = endPage - 4

    if (Number(totalPages) <=5) {
      firstPage = 1
      endPage = Number(totalPages)
    }

    if (endPage > Number(totalPages)) {
      endPage = Number(totalPages)
    }

    if (firstPage <= 0) {
      firstPage = 1
    }

    const extraPage = maxPagesShown - ((endPage - firstPage) +1)

    if (extraPage > 0) {
      if ((endPage + extraPage) <= totalPages){
        endPage = endPage + extraPage
      } else {
        if ((firstPage - extraPage) >= 1) {
          firstPage = firstPage - extraPage
        }
      }
    }

    const pageList = Array.from({ length: (endPage - firstPage) / 1 + 1}, (_, i) => firstPage + (i * 1));

    return(
      <Fragment>
        {
          pageList.map((page) => {
            const buttonClass = `page-button${(Number(currentPage) === page) ? ' -disabled' : '' } number-button`;
            return (
              <button
                disabled={(Number(currentPage) === page)}
                key={page}
                className={buttonClass}
                value={Number(page)}
                onClick={event => this.handlePageClick(event)}
              >
                {page}
              </button>
            );
          })
        }
      </Fragment>
    )
  }

  nextButtonDisabled() {
    const {currentPage, totalPages} = this.props;

    return (currentPage >= totalPages) ? "-disabled" : ""
  }

  previousButtonDisabled() {
    const {currentPage} = this.props;

    return (currentPage <= 1) ? "-disabled" : ""
  }

  render(){
    return(
      <section className="cardSection _navigation pagination">
        <div className="_left result-count">
          <p className="label">
            Total of <strong> {this.props.totalCount.toLocaleString()} </strong> records.
          </p>
        </div>
        <div className="_right">
          <div className="ds-buttonGroup">
            <button
              disabled={this.props.currentPage <= 1}
              className={`page-button prev-button ${this.previousButtonDisabled()}`}
              onClick={event => this.handleFastRewindClick(event)}
            >
              <i className="materialIcon --small"> fast_rewind </i>
            </button>
            <button
              disabled={this.props.currentPage <= 1}
              className={`page-button prev-button ${this.previousButtonDisabled()}`}
              onClick={event => this.handlePreviousButtonClick(event)}
            >
              Prev
            </button>
            {this.renderPageButtons()}
            <button
              disabled={this.props.currentPage >= this.props.totalPages}
              className={`page-button next-button ${this.nextButtonDisabled()}`}
              onClick={event => this.handleNextButtonClick(event)}
            >
              Next
            </button>
            <button
              disabled={this.props.currentPage >= this.props.totalPages}
              className={`page-button next-button ${this.nextButtonDisabled()}`}
              onClick={event => this.handleFastForwardClick(event)}
            >
              <i className="materialIcon --small"> fast_forward </i>
            </button>
          </div>
        </div>
      </section>
    )
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/features/shared/components/Pagination.js